// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2rG2c","rightAdornment":"Header_rightAdornment__2ZzaI"};